import "./SearchBar.css";
import { FaSearch } from "react-icons/fa";
import { useState } from "react";
import SearchSuggestions from "./SearchSuggestions";

function SearchBar() {
  const [search, setSearch] = useState("");
 
  const handleSearch = () => {
    if (!search.trim()) return;

    console.log("Searching:", search);

    // Later:
    // navigate(`/search?q=${search}`);
  };

  return (
    <div className="search-container">
      <div className="search-box">
    

        <FaSearch className="search-icon" />

        <input
          type="text"
          placeholder="Search food, restaurants, home chefs..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
        />
        
   


      </div>
          
    </div>
  );
}

export default SearchBar;